export const inspectionAttachmentsKeys = {
    all: ['inspection-attachments'],
    inspection: (inspectionId) => [...inspectionAttachmentsKeys.all, inspectionId],
    subcontractorPdfs: (inspectionId) => [...inspectionAttachmentsKeys.all, 'subcontractor-pdfs', inspectionId]
};
